import * as React from "react";
import { PropTypes } from "react-router";

export interface SliderProps {
    minValue:number;
    maxValue: number;
    updateHandler: (e: any) => any;
    value: number;
    step?: number;
}

export default class SliderComponent extends React.Component<SliderProps>{
    constructor(props: SliderProps) {
        super(props);
    }
    inputHandler = (e: any) => {
        const value = e.target.value
        this.props.updateHandler(Number(value));
    }
    render(){
       let step = this.props.step ? this.props.step : 1;
        return(
         <div className="slider-container">
           <div className="slider-color">
             <div className="green">
             <div className="no-pain">No Pain</div>
             </div>
             <div className="yellow">
             <div className="moderate-pain">Moderate Pain</div>
             </div>
             <div className="red">
             <div className="unbearable-pain">Unbearable Pain</div>
             </div>
           </div>
         <input type="range" min={this.props.minValue} step={step} max={this.props.maxValue} value={this.props.value} onChange={this.inputHandler} className="slider">
         </input>
         </div>
        );
    }
}